export const MAP_SEARCH_PERSIST_ENABLED_KEY = "mapSearchPersistEnabled";
export const MAP_SEARCH_PERSIST_DATA_KEY = "mapSearchPersistData";

export const readMapSearchPersistEnabled = () =>
  localStorage.getItem(MAP_SEARCH_PERSIST_ENABLED_KEY) === "true";

export const writeMapSearchPersistEnabled = (enabled) => {
  localStorage.setItem(MAP_SEARCH_PERSIST_ENABLED_KEY, enabled ? "true" : "false");
};

export const readMapSearchPersistData = () => {
  try {
    const raw = localStorage.getItem(MAP_SEARCH_PERSIST_DATA_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
};

export const writeMapSearchPersistData = (data) => {
  if (!data) {
    localStorage.removeItem(MAP_SEARCH_PERSIST_DATA_KEY);
    return;
  }
  localStorage.setItem(MAP_SEARCH_PERSIST_DATA_KEY, JSON.stringify(data));
};

export const clearMapSearchPersistData = () => {
  localStorage.removeItem(MAP_SEARCH_PERSIST_DATA_KEY);
};

/** Fallback viewport when the org list has not stored bounds yet (map pan/zoom only). */
export const readMapViewportCenterFromStorage = () => {
  const latitude = Number(localStorage.getItem("lat"));
  const longitude = Number(localStorage.getItem("lng"));
  const zoom = Number(localStorage.getItem("zoom"));
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  return {
    center: { latitude, longitude },
    zoom: Number.isFinite(zoom) ? zoom : undefined,
  };
};

export const buildMapSearchPersistPayload = (query, viewportBounds, searchLocation) => {
  const trimmed = (query || "").trim();
  if (!trimmed) return null;
  const bounds = viewportBounds?.bounds ?? viewportBounds ?? null;
  const centerFallback = bounds?.center ? null : readMapViewportCenterFromStorage();
  const payload = {
    query: trimmed,
    bounds: bounds || centerFallback,
  };
  if (
    searchLocation &&
    Number.isFinite(Number(searchLocation.latitude)) &&
    Number.isFinite(Number(searchLocation.longitude))
  ) {
    payload.searchLocation = {
      latitude: Number(searchLocation.latitude),
      longitude: Number(searchLocation.longitude),
      label: searchLocation.label || trimmed,
      ...(Number.isFinite(Number(searchLocation.zoom))
        ? { zoom: Number(searchLocation.zoom) }
        : {}),
    };
  }
  return payload;
};
